<mat-option #selectAllOption [value]="model.value" (click)="toggleSelection(selectAllOption.selected)" class="bottom-divider">{{ text }}</mat-option>
